import { Heading, Para } from 'ui-components';
import StylistList from './StylistList';
import { CompleteStoreFragment } from 'drycut-graphql';
import { StoreWaitingTime } from 'controlled-components';

type Props = {
  store: CompleteStoreFragment;
};

export default function StepWaitingTime({ store }: Props): JSX.Element {
  return (
    <>
      {store.openNow ? (
        <Para>Buche jetzt den nächsten verfügbaren Slot in</Para>
      ) : (
        <Para className="text-xl lg:text-base">Nächster freier Termin</Para>
      )}

      <Heading variant="h3" className="mb-2">
        <StoreWaitingTime store={store} approximate showZero steps />
        <StylistList stylists={store.checkedInStylists} />
      </Heading>
    </>
  );
}
